import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import BodySmallRegular from "../designSystem/BodySmallRegular";
import Loader from "../subComponents/Loader";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import './DynamicTable.css'
import { t } from "../../locales/translate";
import { type } from "jquery";

const TruncateWithMui = ({ text }) => {
  const ref = React.useRef(null);
  const [enabled, setEnabled] = React.useState(false);

  const handleEnter = () => {
    const el = ref.current;
    if (el) setEnabled(el.scrollWidth > el.clientWidth);
  };

  return (
    <Tooltip title={text || ""} disableHoverListener={!enabled} arrow>
      <span
        ref={ref}
        onMouseEnter={handleEnter}
        style={{
         display: "inline-block",maxWidth: "100%",overflow: "hidden", textOverflow: "ellipsis",whiteSpace: "nowrap",
        }}
      >
        {text}
      </span>
    </Tooltip>
  );
};

const DynamicTable = ({
  data = [],
  isLoading,
  columns = [],
  permissions,
  actions = [],
  customRowRenderer,
  emptyMessage =`${t("noDataFound")}`,
  // Pagination props - made optional
  showPagination = false,
  currentPage,
  totalItems,
  itemsPerPage,
  totalPages,
  onPageChange,
  onItemsPerPageChange
}) => {
  return (
    <div className="dynamic-table-wrapper">
      <div className="dynamic-table-container">
        <table>
          <thead>
            <tr>
              {columns?.map((col, index) => (
                <th key={index}>
                  <div className="header-with-icon">
                    <p></p>
                    <span className="tableheadingtext">{col.label}</span>
                  </div>
                </th>
              ))}
              {actions && actions.length > 0 && <th></th>}
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={columns?.length + (actions && actions.length > 0 ? 1 : 0)} style={{ textAlign: "center" }}>
                  <Loader colored={true} />
                </td>
              </tr>
            ) : data?.length === 0 ? (
              <tr>
                <td colSpan={columns?.length + (actions && actions.length > 0 ? 1 : 0)} style={{ textAlign: "center" }}>
                  {emptyMessage}
                </td>
              </tr>
            ) : customRowRenderer ? (
              // Use custom row renderer if provided
              data?.map((row, rowIndex) => customRowRenderer(row, rowIndex))
            ) : (
              // Default row rendering
              data?.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns?.map((col, colIndex) => {
                    return (
                    <td
                      key={colIndex}
                      style={{
                      width: `${100 / columns.length}%`, maxWidth:"40%",textAlign: col.align || "left",
                      ...(typeof row[col.accessor] === 'object' ? {} :{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      })

                      }}
                    >    
                      {
                      typeof row[col.accessor] === 'object' ? (
                        row[col.accessor]) : (
                        <TruncateWithMui text={row[col.accessor]}/>)
                      }
                    </td>
                      );
                  })}
                  {actions && actions.length > 0 && (
                    <td>
                      {actions?.map((action, actionIndex) => {
                        if (action.type === "handle") {
                          return (
                            <Tooltip key={actionIndex} title={action.label} arrow>
                              <IconButton onClick={() => action.linkTo(row)}>
                                {action.icon}
                              </IconButton>
                            </Tooltip>
                          );
                        }
                        if (permissions && permissions.includes(action.permission)) {
                          return (
                            <Tooltip key={actionIndex} title={action.label} arrow>
                              <IconButton onClick={() => action.handler(row)}>
                                {action.icon}
                              </IconButton>
                            </Tooltip>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Sticky bottom pagination footer */}
      {/* {showPagination && (
        <div className="table-pagination-footer">
          <div className="pagination-controls">
            <div className="items-per-page-container">
              <ItemsPerPageSelector
                value={itemsPerPage}
                onChange={onItemsPerPageChange}
              />
            </div>
            <CustomPagination
              currentPage={currentPage}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </div>
        </div>
      )} */}
    </div>
  );
};

export default DynamicTable;